import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogModel } from './confirmation-dialog.models';
import { ButtonUIComponent } from '../button/button.component';
import { IconUIComponent } from '../icon/icon.component';

@Component({
  selector: 'fr8bot-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  imports: [CommonModule, TranslatePipe, IconUIComponent, ButtonUIComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  data = inject<ConfirmationDialogModel>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<ConfirmationDialogComponent>>(MatDialogRef);

  closeDialog(result?: boolean) {
    this.dialogRef.close(result);
  }
}
